import { initCore } from 'src/lib/init.js'
import { load_json_script } from 'src/lib/json-script.js'
import { DataSet } from 'vis-data/peer'
import { Network } from 'vis-network/peer'

import 'vis-network/styles/vis-network.css';
import 'src/styles/metadata_map.css'

// This code is specific to the metadata map page

// Fetch data suitable for display with vis
function fetchData() {
    const nodes = new DataSet(load_json_script('meatballs-data'))
    const edges = new DataSet(load_json_script('spaghetti-data'))

    return {
        nodes: nodes,
        edges: edges,
    }
}

// Create vis network
function createNetwork(data) {
    const container = document.getElementById('visualization')
    const groups = load_json_script('groups-data')

    const options = {
        groups: groups,
        interaction: {
            tooltipDelay: 99999,
        },
        edges: {
            arrows: {
                to: {
                    enabled: true,
                },
            },
        },
        physics: {
            enabled: true,
            stabilization: true,
            forceAtlas2Based: {
                damping: 1,
                springConstant: 1000,
                springLength: 250,
                avoidOverlap: 1
            },
        },
    }

    let network = new Network(container, data, options)

    network.on("doubleClick", function(params) {
        if (params.nodes.length == 1) {
            if (network.isCluster(params.nodes[0]) == true) {
                network.openCluster(params.nodes[0])
            }
        }
    })

    const details = document.getElementById('details')
    const detailsBlankText = details.textContent

    network.on("click", function(params) {
        const node = network.body.nodes[params.nodes]
        const edge = network.body.edges[params.edges]
        if (node) {
            details.innerHTML = '' + node.options.title
        } else if (edge) {
            const edge_data = data.edges.get(edge.id)
            // edge_data will be null here when clicking on an edge to or from a collapsed node
            if (edge_data) {
                let template = "<div class='edge_information'><dl>"
                template += "<dt>Relation name</dt><dd>"+edge.title+"</dd>"
                template += "<dt>Help</dt><dd>"+edge_data.data.help_text+"</dd>"
                template += "<dt>From model</dt><dd>"+edge_data.data.from_model+"</dd>"
                template += "<dt>To model</dt><dd>"+edge_data.data.to_model+"</dd>"
                template += "</dl></div>"

                details.innerHTML = template
            }
        } else {
            details.textContent = detailsBlankText
        }
    })

    return network
}

function uncluster(network, data) {
    network.setData(data)
}

function clusterByComponent(network, data) {
    network.setData(data)
    let collapsedData = {}
    for (let node of data.nodes.get()) {
        if (collapsedData[node.data.main_model] !== undefined) {
            collapsedData[node.data.main_model].nodes.push(node)
        } else {
            collapsedData[node.data.main_model] = {nodes: [node]}
        }
        if (!node.data.is_component) {
            collapsedData[node.data.main_model].main = node
        }
    }

    for (let col of Object.values(collapsedData)) {
        if (col.nodes.length > 1) {
            let main_node = col.main
            let main_node_data = network.body.nodes[main_node.id]
            let clusterOptionsByData = {
                joinCondition: function(childOptions) {
                    if (childOptions.data === undefined) {
                        return false
                    }
                    return childOptions.data.main_model === main_node.data.main_model
                },
                processProperties: function(clusterOptions) {
                    return clusterOptions
                },
                clusterNodeProperties: {
                    id: "cluster:" + main_node.data.main_model,
                    borderWidth: 4,
                    shape: main_node.shape,
                    color: main_node_data.options.color,
                    label: main_node.label,
                    data: main_node.data,
                    title: main_node.title,
                },
            }
            network.cluster(clusterOptionsByData)
        }
    }
}

function initPage() {
    const data = fetchData()
    let network = createNetwork(data)

    // Handle button clicks
    document.getElementById('hide-all-button').addEventListener('click', () => {
        clusterByComponent(network, data)
    })
    document.getElementById('show-all-button').addEventListener('click', () => {
        uncluster(network, data)
    })
}

initCore()
initPage()
